import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M21.375 12.625h-2.5a.624.624 0 1 0 0 1.25h2.5a.624.624 0 1 0 0-1.25M11.375 3.25v2.5a.624.624 0 1 0 1.25 0v-2.5a.624.624 0 1 0-1.25 0M2 12.625c0 .346.28.625.625.625h2.5a.624.624 0 1 0 0-1.25h-2.5a.624.624 0 0 0-.625.625M4.93 5.554a.624.624 0 0 0 0 .884l1.767 1.768a.623.623 0 0 0 .884 0 .624.624 0 0 0 0-.884L5.813 5.554a.624.624 0 0 0-.884 0M16.861 8.389c.16 0 .32-.061.442-.183l1.768-1.768a.624.624 0 1 0-.884-.884l-1.768 1.768a.624.624 0 0 0 .442 1.067"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M21.375 14.5h-4.152c.256-.55.402-1.135.402-1.875A5.63 5.63 0 0 0 12 7a5.63 5.63 0 0 0-5.625 5.625c0 .74.146 1.325.402 1.875H2.625a.624.624 0 1 0 0 1.25h18.75a.624.624 0 1 0 0-1.25m-13.172 0c-.383-.606-.578-1.11-.578-1.875A4.38 4.38 0 0 1 12 8.25a4.38 4.38 0 0 1 4.375 4.375c0 .764-.195 1.269-.578 1.875zM12.443 16.559a.624.624 0 0 0-.886 0l-1.873 1.874a.624.624 0 1 0 .884.884l.807-.808v2.241a.624.624 0 1 0 1.25 0v-2.241l.807.808a.623.623 0 0 0 .884 0 .624.624 0 0 0 0-.884z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }